import type { ReactNode } from "react";
import { MinusIcon, PlusIcon, RotateCwIcon } from "lucide-react";

import { Row } from "@/components/Row";
import { Text } from "@/components/Text";
import { Button } from "@ui/button";

import { cn } from "@/lib/utils";

const SCALE_STEP = 0.1;

// One toolbar for whichever topper or accessory the active slot holds.
export const ShopAdjustControls = ({
  itemLabel,
  leadingControl,
  onRotate,
  onScaleChange,
}: {
  itemLabel: string;
  // Item-specific control shown before the drag hint (e.g. the crown toggle).
  leadingControl?: ReactNode;
  onRotate?: () => void;
  onScaleChange: (amount: number) => void;
}) => {
  return (
    <Row
      className={cn(
        "flex-wrap items-center gap-2 border-2 border-slate-900 bg-white px-2 py-1.5",
        // A leading control pins left; the drag hint and sizing sit right.
        leadingControl ? "justify-between" : "justify-center",
      )}
    >
      {leadingControl}
      <Row className="items-center gap-2">
        <Text className="font-mono text-[9px] font-black uppercase tracking-[0.1em] text-violet-700">
          Drag {itemLabel} to move
        </Text>
        <Row className="items-center gap-1">
          <Text className="mr-1 font-mono text-[8px] font-black uppercase tracking-[0.1em] text-slate-500">
            Size
          </Text>
          <Button
            type="button"
            variant="outline"
            onClick={() => {
              onScaleChange(-SCALE_STEP);
            }}
            className="h-7 w-7 rounded-none border-2 border-slate-900 p-0"
          >
            <MinusIcon className="h-3 w-3" />
          </Button>
          <Button
            type="button"
            variant="outline"
            onClick={() => {
              onScaleChange(SCALE_STEP);
            }}
            className="h-7 w-7 rounded-none border-2 border-slate-900 p-0"
          >
            <PlusIcon className="h-3 w-3" />
          </Button>
          {onRotate ? (
            <Button
              type="button"
              variant="outline"
              onClick={onRotate}
              className="h-7 w-7 rounded-none border-2 border-slate-900 p-0"
            >
              <RotateCwIcon className="h-3 w-3" />
              <Text className="sr-only">Rotate 45°</Text>
            </Button>
          ) : null}
        </Row>
      </Row>
    </Row>
  );
};
